<template>
<div class="animated fadeIn">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>{{$t('WEEKLYMINIMUMPLAYNNER')}}: {{moment(date).day(6).format('ddd-MMM/DD/YY')}}</h3>
      </div>
      <div class="col-md-4 m-auto">
        <b-form-select :options="store.root" v-model="comboStoreId" value-field="storeId" text-field="name">
        </b-form-select>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-5">
          <button type="button" class="btn btn-secondary" @click="getDateObject('previous')">
            <!-- icon icon="plus"></icon --> {{$t('PREVIOUSWEEK')}}
          </button>
        </div>
        <div class="col-sm-2">
          <div class="row">
            <icon icon="calendar-check" @click="openCalendat()" class="mt-2 mr-2"></icon>
            <datepicker ref="datepicker" name="startDate" v-model="calendarDate"></datepicker>
          </div>
        </div>
        <div class="col-sm-5">
          <button type="button" class="btn btn-secondary float-right" @click="getDateObject('next')">
            <!-- icon icon="plus"></icon --> {{$t('NEXTWEEK')}}
          </button>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('NAME')}}</th>
                <th>{{$t('EMPLOYEESALESHOURS')}}</th>
                <th>{{$t('STOREHOURS%')}}</th>
                <th>{{$t('ACTUALSALES')}}</th>
                <th>{{$t('GOLDSTAR')}}</th>
                <th>{{$t('TOREACHGOLDSTAR')}}</th>
                <th>{{$t('ACTUALSALES')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in response.root">
                <tr aria-rowindex="1" class=" table-ellipsis" :style="item.total == 1 ? 'background-color: #d0e7b5;' : ''">
                  <td>{{item.name}}</td>
                  <td :class="(item.total == 0) ? (item.statistics.employeeSalesHours >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">{{item.statistics.employeeSalesHours}}</td>
                  <td :class="(item.total == 0) ? (item.statistics.storeHours >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">{{item.statistics.storeHours}} %</td>
                  <td :class="(item.total == 0) ? (item.statistics.actualSales >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">${{item.statistics.actualSales}}</td>
                  <td :class="(item.total == 0) ? (item.statistics.goldStar >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">${{item.statistics.goldStar}}</td>
                  <td :class="(item.total == 0) ? (item.statistics.toReachGoldStar >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">${{item.statistics.toReachGoldStar}}</td>
                  <td :class="(item.total == 0) ? (item.statistics.actualSales >= 0 ? 'table-statistics-above-backgrouncolor' : 'table-statistics-under-backgrouncolor') : ''">${{item.statistics.actualSales}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import moment from 'moment';

import StoreApi from '@/api/salesportal/Store'
import BudgetApi from '@/api/salesportal/Budget'

export default
{
  name: 'ScheduleWin',
  props: ['storeId', 'tabIndex', 'tabIndexParent'],
  components:
  {

  },
  data: function()
  {
    return {
      date: moment().format('YYYY-MM-DD'),
      calendarDate: null,
      dates: [],
      store:
      {},
      comboStoreId: null,
      response:
      {}
    }
  },
  async created()
  {
    var me = this;
    //me.setWeek();
    me.getStore();
  },
  methods:
  {
    openCalendat()
    {
      var me = this;
      me.$refs.datepicker.$children[0].$emit('showCalendar')
    },
    getDateObject(item)
    {
      var me = this;

      if (typeof item !== 'undefined' && item == 'previous')
      {
        me.date = moment(me.date).subtract(7, 'days').format('YYYY-MM-DD');
      }
      else if (typeof item !== 'undefined' && item == 'next')
      {
        me.date = moment(me.date).add(7, 'days').format('YYYY-MM-DD');
      }
    },
    setWeek()
    {
      var me = this;
      me.dates = [];
      for (var i = 0; i < 7; i++)
      {
        me.dates.push(moment(me.date).day(i).format('YYYY-MM-DD'));
      }
    },
    async getStore()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.store = data;

        me.comboStoreId = (typeof me.storeId !== 'undefined' && me.storeId != '') ? me.storeId : me.store.root[0].storeId;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getData()
    {
      var me = this;
      try
      {
        var data = await BudgetApi.getWeeklyMinimumPlanner(
        {
          date: me.date,
          storeId: me.comboStoreId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {
    date(val)
    {
      var me = this;
      me.setWeek();
      me.getData();
    },
    calendarDate(val)
    {
      var me = this;
      me.date = moment(val).format('YYYY-MM-DD');
    },
    comboStoreId(val)
    {
      var me = this;
      me.getData();
    },
    async tabIndex(val)
    {
      var me = this;
      try
      {
        if (val == 1)
        {
          await me.setWeek();
          await me.getStore();
          await me.getData();
        }
      }
      catch (error)
      {
        me.$notify.notice(e);
      }
    },
    async tabIndexParent(val)
    {
      var me = this;
      try
      {
        var parentTabKey = 3;
        if(me.globals.groupId == 4)
        {
          parentTabKey=1
        }

        if (val == parentTabKey && me.tabIndex == 1)
        {
          await me.setWeek();
          await me.getStore();
          await me.getData();
        }
      }
      catch (error)
      {
        me.$notify.notice(e);
      }
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
